import type { DriveStep } from 'driver.js';

export const adminBranchesTourId = 'admin:branches';

export const adminBranchesSteps: DriveStep[] = [
  {
    element: '[data-tour="admin:branches-search"]',
    popover: {
      title: 'Поиск',
      description:
        'Поиск по названию или адресу пункта выдачи.',
    },
  },
  {
    element: '[data-tour="admin:branches-list"]',
    popover: {
      title: 'Пункты выдачи',
      description:
        'Список всех пунктов выдачи. Кликните на строку для просмотра деталей: адрес, координаты, рабочие часы.',
    },
  },
  {
    element: '[data-tour="admin:help-btn"]',
    popover: {
      title: 'Помощь',
      description:
        'Помощь.',
    },
  },
];
